<template>
<div class="chapter">
<div class="inner_page">
<p><img alt="" height="700" src="image/93620.png" width="460"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// APerfectSecreteBook.vue?343584f2